/**
 * OptimizationRecommendation Enhanced Component
 * Wrapper around OptimizationRecommendationViewer with enhanced layout
 */

import { Container, Paper, Title } from '@mantine/core';
import React from 'react';
import { OptimizationRecommendationViewer } from '../OptimizationRecommendationViewer';

interface OptimizationRecommendationEnhancedProps {
    data?: {
        workflowId?: string;
        workflowName?: string;
        recommendations?: any[];
    };
    mode?: 'view' | 'analyze' | 'approve' | 'implement' | 'history' | 'generate';
    tenant?: string;
}

export const OptimizationRecommendationEnhanced: React.FC<OptimizationRecommendationEnhancedProps> = ({
    data,
    mode = 'view',
    tenant
}) => {
    const workflowId = data?.workflowId || 'optimization-workflow';

    return (
        <Container size="xl">
            <Paper shadow="sm" p="lg">
                <Title order={2} mb="md">AI Optimization Recommendations</Title>
                <OptimizationRecommendationViewer
                    workflowId={workflowId}
                    workflowName={data?.workflowName}
                    tenant={tenant}
                    mode={mode}
                    recommendations={data?.recommendations || []}
                    onGenerate={async () => {
                        throw new Error('INTEGRATION_REQUIRED: Generate action requires proper GraphQL mutation wiring via EnhancedComponentProvider. This enhanced wrapper does not provide persistence.');
                    }}
                    onGenerateNew={async () => {
                        throw new Error('INTEGRATION_REQUIRED: Generate New action requires proper GraphQL mutation wiring via EnhancedComponentProvider. This enhanced wrapper does not provide persistence.');
                    }}
                    onApprove={async () => {
                        throw new Error('INTEGRATION_REQUIRED: Approve action requires proper GraphQL mutation wiring via EnhancedComponentProvider. This enhanced wrapper does not provide persistence.');
                    }}
                    onImplement={async () => {
                        throw new Error('INTEGRATION_REQUIRED: Implement action requires proper GraphQL mutation wiring via EnhancedComponentProvider. This enhanced wrapper does not provide persistence.');
                    }}
                    onSimulate={async () => {
                        throw new Error('INTEGRATION_REQUIRED: Simulate action requires proper GraphQL mutation wiring via EnhancedComponentProvider. This enhanced wrapper does not provide persistence.');
                    }}
                    onRefresh={async () => {
                        throw new Error('INTEGRATION_REQUIRED: Refresh action requires proper GraphQL query wiring via EnhancedComponentProvider. This enhanced wrapper does not provide data fetching.');
                    }}
                    onExport={async () => {
                        throw new Error('INTEGRATION_REQUIRED: Export action requires proper GraphQL mutation wiring via EnhancedComponentProvider. This enhanced wrapper does not provide persistence.');
                    }}
                />
            </Paper>
        </Container>
    );
};

export default OptimizationRecommendationEnhanced;


